module.exports = __webpack_public_path__ + "img/baIcon.1b445e13.png";